import { createElement, forwardRef } from 'react';
import type { ClassValue } from 'clsx';
import clsx from 'clsx';

import type { Sprinkles } from '../../css/sprinkles.css';
import { sprinkles } from '../../css/sprinkles.css';
import { hiddenScroll as styles_hiddenScroll } from './Box.css';

export type BoxProps = Sprinkles &
  React.PropsWithChildren &
  Omit<React.AllHTMLAttributes<HTMLElement>, 'color' | 'height' | 'width' | 'className'> & {
    as?: React.ElementType;
    // Can't use className because it does some conversion on its values and
    // breaks values like arrays, which would otherwise be valid for clsx.
    cssClass?: ClassValue | ClassValue[];
    hiddenScroll?: boolean;
  };

export type PaddingProps = {
  padding?: BoxProps['p'];
  paddingTop?: BoxProps['p'];
  paddingRight?: BoxProps['p'];
  paddingBottom?: BoxProps['p'];
  paddingLeft?: BoxProps['p'];
  p?: BoxProps['p'];
  px?: BoxProps['px'];
  py?: BoxProps['py'];
};

export const Box = forwardRef<unknown, BoxProps>(({ as = 'div', cssClass, hiddenScroll, ...props }, ref) => {
  const sprinklesProps: Record<string, unknown> = {};
  const nativeProps: Record<string, unknown> = {};
  const userClasses = clsx(cssClass);

  // oxlint-disable gonfalon/no-for-in
  // eslint-disable-next-line no-restricted-syntax
  for (const key in props) {
    if (sprinkles.properties.has(key as keyof Sprinkles)) {
      const value = props[key as keyof typeof props];
      if (value !== undefined) {
        sprinklesProps[key] = value;
      }
    } else {
      nativeProps[key] = props[key as keyof typeof props];
    }
  }
  // oxlint-enable gonfalon/no-for-in

  return createElement(as, {
    className: clsx([sprinkles(sprinklesProps), userClasses, { [styles_hiddenScroll]: hiddenScroll }]),
    ref,
    ...nativeProps,
  });
});

// Required because of using forwardRef
Box.displayName = 'Box';
